import {
  AppSources,
  Channel,
  InternalApiSources,
  OAuthApiSources,
} from './AuditService'
import servicesConfig, { CustomAxiosHeaders } from '../config/services'

import { requests } from '.'

// use serviceName value below as key in `versions` object in `src/config/services.ts` for developer versions
const serviceName = 'BusinessService'
const host = servicesConfig.Business
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

export interface updateOrCreatedBy {
  userId: string
  source: AppSources | OAuthApiSources | InternalApiSources
  channel: Channel
  sourceId: string
  sourceName: string
  name: string
  createdAt: string
}

export interface IBusiness {
  id: string
  name: string
  phone?: string
  email?: string
  website?: string
  address?: string
  city?: string
  state?: string
  postalCode?: string
  description? : string
  country?: string
  lastContactedDate?: Date
  deleted?: Boolean
  updatedBy?: updateOrCreatedBy
  locationId: string
  createdBy?: updateOrCreatedBy
  deletedBy?: updateOrCreatedBy
  createdAt?: Date
  updatedAt?: Date
}

export interface IBusinessSearchResponse {
  businesses: IBusiness[]
  count: number
}

export interface IBusinessBulkDeleteParams {
  ids : string[],
  locationId : string
}

export interface IBusinessBulkDeleteRespomse {
  ids: string[]
  success : boolean
}
export interface IBusinessByIdResponse {
  business: IBusiness
  success : boolean
}

export interface IBusinessMigrationResponse {
  enabled:  boolean
  success : boolean
  locationId : string
}
export interface IBusinessUpdateByIdResponse {
  business: IBusiness
}

export interface IBusinessSearchPayload {
  locationId: string
  query: string
  skip: string
  limit: string
}

export interface IBusinessByIdPayload {
  locationId: string
  id: String
}


const BusinessService = {
  search: (payload: IBusinessSearchPayload) =>
    request().get<IBusinessSearchResponse>(`/search`, {
      params: {
        limit: payload.limit,
        skip: payload.skip,
        locationId: payload.locationId,
        query: payload.query,
        count :true
      },
    }),

  updateById: (payload: IBusiness) =>
    request().put<IBusinessByIdResponse>(
      `/${payload.id}`,
      {
        name: payload.name,
        phone : payload.phone,
        email : payload.email,
        website : payload.website,
        address: payload.address,
        city : payload.city,
        state : payload.state,
        postalCode : payload.postalCode,
        description : payload.description,
        country : payload.country,
      }
    ),

  getById: (payload: IBusinessByIdPayload) =>
    request().get<IBusinessByIdResponse>(
      `/${payload.id}`
    ),

    save: (payload: IBusiness) =>
    request().post<IBusinessByIdResponse>(
      `/`,
      {

          name: payload.name,
          phone : payload.phone,
          email : payload.email,
          website : payload.website,
          address: payload.address,
          city : payload.city,
          state : payload.state,
          postalCode : payload.postalCode,
          description : payload.description,
          country : payload.country,
          locationId: payload.locationId,

      }
    ),
    deleteById: (payload: IBusinessByIdPayload) =>
    request().delete<IBusinessByIdResponse>(
      `/${payload.id}`
    ),
    bulkDelete: (payload: IBusinessBulkDeleteParams) =>
    request().post<IBusinessBulkDeleteRespomse>(
      `/bulk/delete`,
      {
          businessIds: payload.ids,
          locationId: payload.locationId,
      }
    ),
}

export default BusinessService
